/**
 * kw-favorites.js — site-wide "Add to favorites" using localStorage.
 * - Injects heart button on every product card and on PDPs
 * - Header shows count badge linking to /pages/favorites
 * - /pages/favorites renders the saved grid client-side
 */
(function () {
  var KEY = 'kw-favorites';
  var favs = load();

  function load() {
    try { return JSON.parse(localStorage.getItem(KEY) || '[]'); } catch (e) { return []; }
  }
  function persist() {
    try { localStorage.setItem(KEY, JSON.stringify(favs)); } catch (e) {}
    refreshAll();
  }
  function isFav(h) { return favs.indexOf(h) > -1; }
  function toggle(h) {
    var i = favs.indexOf(h);
    var wasFav = i > -1;
    if (wasFav) favs.splice(i, 1); else favs.push(h);
    persist();
    if (!wasFav) {
      document.dispatchEvent(new CustomEvent('kw:favorite-added', { detail: { handle: h } }));
    } else {
      document.dispatchEvent(new CustomEvent('kw:favorite-removed', { detail: { handle: h } }));
    }
  }
  function heart(filled) {
    var fill = filled ? '#c02020' : 'none';
    var stroke = filled ? '#c02020' : 'currentColor';
    return '<svg viewBox="0 0 24 24" width="18" height="18" fill="' + fill + '" stroke="' + stroke + '" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/></svg>';
  }
  function handleFromHref(a) {
    if (!a) return null;
    var m = a.getAttribute('href').match(/\/products\/([a-z0-9-]+)/i);
    return m ? m[1] : null;
  }
  function currentPdpHandle() {
    var m = window.location.pathname.match(/\/products\/([a-z0-9-]+)/i);
    return m ? m[1] : null;
  }

  // --- Product cards -----------------------------------------------------
  function attachCards() {
    document.querySelectorAll('product-card:not([data-kw-fav])').forEach(function (card) {
      var a = card.querySelector('a[href*="/products/"]');
      var h = handleFromHref(a);
      if (!h) return;
      card.setAttribute('data-kw-fav', h);
      if (getComputedStyle(card).position === 'static') card.style.position = 'relative';
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'kw-fav-card-btn';
      btn.setAttribute('aria-label', isFav(h) ? 'Remove from favorites' : 'Add to favorites');
      btn.style.cssText = 'position:absolute;top:10px;right:10px;z-index:10;width:34px;height:34px;border-radius:50%;background:rgba(255,255,255,0.9);border:1px solid rgba(0,0,0,0.05);display:inline-flex;align-items:center;justify-content:center;cursor:pointer;padding:0;color:#4A2E1A;transition:transform 0.15s ease,background 0.15s;';
      btn.innerHTML = heart(isFav(h));
      btn.addEventListener('mouseenter', function () { btn.style.background = '#fff'; });
      btn.addEventListener('mouseleave', function () { btn.style.background = 'rgba(255,255,255,0.9)'; });
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        toggle(h);
        btn.style.transform = 'scale(1.25)';
        setTimeout(function () { btn.style.transform = 'scale(1)'; }, 160);
      });
      card.appendChild(btn);
    });
  }

  // --- PDP button --------------------------------------------------------
  function attachPdp() {
    if (document.getElementById('kw-fav-pdp')) return;
    var h = currentPdpHandle();
    if (!h) return;
    var addBtn = document.querySelector('add-to-cart-component button[name="add"], button[name="add"], .product-form__submit, [data-testid="add-to-cart-button"]');
    if (!addBtn) return;
    var container = addBtn.closest('add-to-cart-component, form, .product-form') || addBtn.parentElement;
    if (!container) return;
    var fav = document.createElement('button');
    fav.id = 'kw-fav-pdp';
    fav.type = 'button';
    fav.style.cssText = 'display:flex;align-items:center;justify-content:center;gap:8px;margin-top:12px;padding:12px 20px;background:transparent;border:1px solid #d5d0c2;border-radius:6px;font-size:0.78rem;letter-spacing:0.14em;text-transform:uppercase;color:#4A2E1A;cursor:pointer;font-family:inherit;font-weight:600;transition:background 0.15s,border-color 0.15s;width:100%;';
    fav.innerHTML = heart(isFav(h)) + '<span id="kw-fav-pdp-label">' + (isFav(h) ? 'Saved to favorites' : 'Add to favorites') + '</span>';
    fav.addEventListener('mouseenter', function () { fav.style.background = '#f4efe4'; });
    fav.addEventListener('mouseleave', function () { fav.style.background = 'transparent'; });
    fav.addEventListener('click', function () { toggle(h); });
    container.insertAdjacentElement('afterend', fav);
  }

  // --- Header icon + badge ----------------------------------------------
  function attachHeader() {
    if (document.getElementById('kw-fav-header')) return;
    var actions = document.querySelector('header-actions');
    if (!actions) return;
    var link = document.createElement('a');
    link.id = 'kw-fav-header';
    link.href = '/pages/favorites';
    link.className = 'header-actions__action';
    link.setAttribute('aria-label', 'Your favorites');
    link.style.cssText = 'position:relative;display:inline-flex;align-items:center;justify-content:center;width:44px;height:44px;color:inherit;text-decoration:none;';
    link.innerHTML = heart(false) +
      '<span id="kw-fav-count" style="position:absolute;top:4px;right:4px;background:#c02020;color:#fff;font-size:10px;font-weight:700;border-radius:999px;min-width:16px;height:16px;padding:0 4px;display:none;align-items:center;justify-content:center;line-height:1;box-sizing:border-box;">0</span>';
    actions.insertBefore(link, actions.firstChild);
    updateHeaderCount();
  }
  function updateHeaderCount() {
    var el = document.getElementById('kw-fav-count');
    if (!el) return;
    if (favs.length > 0) {
      el.textContent = favs.length > 99 ? '99+' : String(favs.length);
      el.style.display = 'inline-flex';
    } else {
      el.style.display = 'none';
    }
  }

  // --- Favorites page ----------------------------------------------------
  function renderFavoritesPage() {
    if (window.location.pathname.replace(/\/$/, '') !== '/pages/favorites') return;
    var root = document.getElementById('kw-favs-root');
    if (!root) {
      var mount = document.querySelector('.rte, .page__content, main .content-for-layout, main');
      if (!mount) return;
      root = document.createElement('div');
      root.id = 'kw-favs-root';
      mount.appendChild(root);
    }
    if (root.dataset.kwRendered === '1') return;
    root.dataset.kwRendered = '1';
    root.innerHTML =
      '<style>' +
      '.kw-favs-wrap{max-width:1200px;margin:0 auto;padding:24px 20px 80px;font-family:-apple-system,BlinkMacSystemFont,Helvetica,Arial,sans-serif}' +
      '.kw-favs-head{text-align:center;margin-bottom:32px}' +
      '.kw-favs-head h1{font-family:var(--font-heading--family,Georgia),serif;font-size:2.2rem;font-weight:500;color:#1c1c1c;margin:0 0 8px}' +
      '.kw-favs-head p{color:#6a6a6a;font-size:0.95rem;margin:0}' +
      '.kw-favs-grid{display:grid;grid-template-columns:repeat(auto-fill,minmax(240px,1fr));gap:24px}' +
      '.kw-fav-item{background:#fff;border:1px solid #eae4d6;border-radius:8px;overflow:hidden;position:relative;transition:transform 0.15s,box-shadow 0.15s}' +
      '.kw-fav-item:hover{transform:translateY(-2px);box-shadow:0 6px 18px rgba(0,0,0,0.06)}' +
      '.kw-fav-item a{text-decoration:none;color:inherit;display:block}' +
      '.kw-fav-item img{width:100%;aspect-ratio:1;object-fit:cover;display:block;background:#f4efe4}' +
      '.kw-fav-item-body{padding:14px 16px 16px}' +
      '.kw-fav-item-title{font-family:Georgia,serif;font-size:0.95rem;color:#1c1c1c;margin:0 0 6px;line-height:1.35}' +
      '.kw-fav-item-price{font-size:0.9rem;color:#4A2E1A;font-weight:600}' +
      '.kw-fav-remove{position:absolute;top:10px;right:10px;width:34px;height:34px;background:rgba(255,255,255,0.95);border:1px solid rgba(0,0,0,0.05);border-radius:50%;cursor:pointer;padding:0;display:inline-flex;align-items:center;justify-content:center;z-index:5;color:#c02020}' +
      '.kw-favs-empty{text-align:center;padding:80px 20px;color:#6a6a6a;background:#f4efe4;border-radius:8px}' +
      '.kw-favs-empty h2{font-family:var(--font-heading--family,Georgia),serif;color:#1c1c1c;margin:0 0 12px;font-size:1.4rem;font-weight:500}' +
      '.kw-favs-empty p{margin:0 auto 20px;max-width:420px;line-height:1.5}' +
      '.kw-favs-empty a.btn{display:inline-block;padding:12px 26px;background:#1c1c1c;color:#fff;text-decoration:none;border-radius:4px;font-size:0.82rem;letter-spacing:0.12em;text-transform:uppercase;font-weight:600}' +
      '</style>' +
      '<div class="kw-favs-wrap">' +
      '  <div class="kw-favs-head">' +
      '    <h1>Your Favorites</h1>' +
      '    <p id="kw-favs-count-text"></p>' +
      '  </div>' +
      '  <div id="kw-favs-body"></div>' +
      '</div>';

    var body = root.querySelector('#kw-favs-body');
    var countText = root.querySelector('#kw-favs-count-text');

    if (favs.length === 0) {
      countText.textContent = '';
      body.innerHTML =
        '<div class="kw-favs-empty">' +
        '  <h2>Your favorites list is empty</h2>' +
        '  <p>Browse our sculptures and tap the heart to save the pieces you love. They\'ll be here waiting for you.</p>' +
        '  <a class="btn" href="/collections/all">Explore the collection</a>' +
        '</div>';
      return;
    }

    countText.textContent = favs.length + ' saved piece' + (favs.length === 1 ? '' : 's');
    var grid = document.createElement('div');
    grid.className = 'kw-favs-grid';
    body.appendChild(grid);

    favs.slice().forEach(function (h) {
      var slot = document.createElement('div');
      slot.className = 'kw-fav-item';
      slot.dataset.handle = h;
      slot.innerHTML = '<div style="aspect-ratio:1;background:#f4efe4;display:flex;align-items:center;justify-content:center;color:#aaa;font-size:0.75rem;">Loading…</div>';
      grid.appendChild(slot);

      fetch('/products/' + h + '.js').then(function (r) {
        if (!r.ok) throw new Error(r.status);
        return r.json();
      }).then(function (p) {
        var img = p.featured_image || (p.images && p.images[0]) || '';
        if (img && img.indexOf('//') === 0) img = 'https:' + img;
        var price = (p.price / 100).toFixed(2);
        var currency = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
        var titleSafe = String(p.title).replace(/</g, '&lt;').replace(/>/g, '&gt;');
        slot.innerHTML =
          '<a href="/products/' + p.handle + '">' +
          '  <img src="' + img + '" alt="' + titleSafe.replace(/"/g, '&quot;') + '" loading="lazy">' +
          '  <div class="kw-fav-item-body">' +
          '    <h3 class="kw-fav-item-title">' + titleSafe + '</h3>' +
          '    <div class="kw-fav-item-price">$' + price + ' ' + currency + '</div>' +
          '  </div>' +
          '</a>' +
          '<button class="kw-fav-remove" aria-label="Remove from favorites" type="button">' + heart(true) + '</button>';
        slot.querySelector('.kw-fav-remove').addEventListener('click', function (e) {
          e.preventDefault();
          toggle(p.handle);
          slot.style.transition = 'opacity 0.2s, transform 0.2s';
          slot.style.opacity = '0';
          slot.style.transform = 'scale(0.95)';
          setTimeout(function () {
            slot.remove();
            if (!grid.children.length) {
              root.dataset.kwRendered = '';
              renderFavoritesPage();
            } else {
              countText.textContent = favs.length + ' saved piece' + (favs.length === 1 ? '' : 's');
            }
          }, 200);
        });
      }).catch(function () {
        // Product deleted/unpublished — drop it silently
        var idx = favs.indexOf(h);
        if (idx > -1) { favs.splice(idx, 1); persist(); }
        slot.remove();
        if (!grid.children.length) {
          root.dataset.kwRendered = '';
          renderFavoritesPage();
        }
      });
    });
  }

  // --- Sync UI to state --------------------------------------------------
  function refreshAll() {
    updateHeaderCount();
    document.querySelectorAll('[data-kw-fav]').forEach(function (card) {
      var h = card.getAttribute('data-kw-fav');
      var btn = card.querySelector('.kw-fav-card-btn');
      if (btn) {
        btn.innerHTML = heart(isFav(h));
        btn.setAttribute('aria-label', isFav(h) ? 'Remove from favorites' : 'Add to favorites');
      }
    });
    var pdp = document.getElementById('kw-fav-pdp');
    if (pdp) {
      var h = currentPdpHandle();
      if (h) {
        var svgEl = pdp.querySelector('svg');
        if (svgEl) svgEl.outerHTML = heart(isFav(h));
        var lbl = document.getElementById('kw-fav-pdp-label');
        if (lbl) lbl.textContent = isFav(h) ? 'Saved to favorites' : 'Add to favorites';
      }
    }
  }

  function init() {
    attachHeader();
    attachCards();
    attachPdp();
    renderFavoritesPage();
    if (window.MutationObserver) {
      var mo = new MutationObserver(function () {
        attachCards();
        if (!document.getElementById('kw-fav-header')) attachHeader();
        if (!document.getElementById('kw-fav-pdp')) attachPdp();
      });
      mo.observe(document.body, { childList: true, subtree: true });
    }
    window.addEventListener('storage', function (e) {
      if (e.key === KEY) { favs = load(); refreshAll(); }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
